import { select, takeLatest } from 'redux-saga/effects';
import { targetadsPush } from 'src/utils/targetAds/targetadsPush';
import { takeOnce } from 'src/helpers/effects';
import { createOrderSuccess } from 'src/routes/Checkout/store/reducers/order';
import { initTargetads } from 'src/utils/targetAds/initTargetads';
import type { SagaReturnType } from 'redux-saga/effects';
import {
  sendTargetadsPageviewAction,
  sendTargetadsTransactionAction,
} from './actions';
import { getClientId } from '../client/selectors';
import { INIT_APP } from '../view/constants';
import { LT_PROJECT_ID } from './constants';

function* handleInitTargetads() {
  try {
    initTargetads('init', LT_PROJECT_ID);

    const clientId: SagaReturnType<typeof getClientId> = yield select(
      getClientId,
    );
    const params = {
      user: {
        uid: clientId,
      },
    };

    targetadsPush('page_view', params);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

function* handlePageview() {
  try {
    const clientId: SagaReturnType<typeof getClientId> = yield select(
      getClientId,
    );
    const params = {
      user: {
        uid: clientId,
      },
    };
    targetadsPush('page_view', params);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

function handleTransaction() {
  try {
    const data = {
      id: window.PACKAGE.id,
      quantity: 1,
      amount: window.PACKAGE.price,
    };

    const eventParams = {
      event_type: 'transaction',
      event_category: 'transaction',
      event_name: 'transaction',
      event_params: data,
    };

    targetadsPush('transaction', eventParams);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export default function* watchTargetAds() {
  yield takeLatest(INIT_APP, handleInitTargetads);
  yield takeLatest(sendTargetadsPageviewAction, handlePageview);
  yield takeOnce(
    [createOrderSuccess, sendTargetadsTransactionAction],
    handleTransaction,
  );
}
